// useTrustmateWidget.js
import { useEffect } from 'react';
export const useTrustmateWidgetScript = widgetId => {
  useEffect(() => {
    if (!widgetId) return;
    const scriptId = `trustmate-script-${widgetId}`;

    // Jeśli skrypt już jest w DOM, nie dodawaj ponownie
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'text/javascript';
      script.defer = true;
      script.src = `https://trustmate.io/widget/api/${widgetId}/script`;
      document.head.appendChild(script);
    }
  }, [widgetId]);
};